/**
 * @param {object} error - takes an exception and logs to Sentry or the console.
 * @desc use this to throw errors
 * @example
 * try {
 *   throw 'error'
 * } catch (e) {
 *   logger(e);
 * }
 */
const logger = error => {
    if (process && process.env && process.env.NODE_ENV !== 'production') {
        try {
            throw error;
        } catch (e) {
            console.error(e);
        }
        return;
    }

    if (window && window.Raven) {
        if (error instanceof Error) {
            Raven.captureException(error);
        } else {
            try {
                throw new Error(error);
            } catch (e) {
                Raven.captureException(e)
            }
        }
        console.error(error);
    } else {
        console.error(error);
    }
}


export default logger;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/packages/logger.js